import * as t from "io-ts";
import { BadResponseBodyError } from "../../../bad-response-body-error";
import { TransferAnswers } from "../../../types/form/submission/answer";
import { Score } from "../../../types/form/submission/score";
import { FormId } from "../../../types/ids";

export const SubmitFormQuery = t.type({
  id: FormId
});
export type SubmitFormQuery = t.TypeOf<typeof SubmitFormQuery>;

export const SubmitFormRequest = t.type({
  id: FormId,
  answers: TransferAnswers,
  score: Score
});
export type SubmitFormRequest = t.TypeOf<typeof SubmitFormRequest>;

export const SubmitFormResponse = t.type({
  success: t.boolean
});
export type SubmitFormResponse = t.TypeOf<typeof SubmitFormResponse>;
export type SubmitFormResponseOutput = t.OutputOf<typeof SubmitFormResponse>;

export async function submitForm(body: SubmitFormRequest): Promise<SubmitFormResponse> {
  const res = await fetch(`/api/forms/${FormId.encode(body.id)}/submit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(SubmitFormRequest.encode(body)),
  });
  return BadResponseBodyError.throwIfLeft(res.status,
    SubmitFormResponse.decode(await res.json()));
}
